import { Stack } from "@chakra-ui/react";
import { ReactNode } from "react";

interface SidebarNavStackProps {
  children: ReactNode;
}
export function SidebarNavStack({ children }: SidebarNavStackProps) {
  return <Stack pt="4">{children}</Stack>;
}
